import { render, staticRenderFns } from "./Annotator.vue?vue&type=template&id=10f0c904&lang=pug&"
import script from "./Annotator.vue?vue&type=script&lang=js&"
export * from "./Annotator.vue?vue&type=script&lang=js&"
import style0 from "./Annotator.vue?vue&type=style&index=0&id=10f0c904&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports